import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import dashWhite from '../Images/dashboard_white.png'
import dashBlack from '../Images/dashBlack.png'
import consBlack from '../Images/consultations_black.png'
import consWhite from '../Images/consWhite.png'
import docWhite from '../Images/docWhite.png'
import docBlack from '../Images/doctor_black.png'
import patBlack from '../Images/patients_black.png'
import patWhite from '../Images/patWhite.png'
import profile from '../Images/profile.png'
import logoutImg from '../Images/logout.png'
import { useLogout } from '../hooks/useLogout';
import { useAuthContext } from '../hooks/useAuthContext'
import imnLogo from '../Images/imnLogo.png'
import { LogOut, User } from 'lucide-react'




function Sidebar() {
    const location = useLocation();
    const { pathname } = location;
    const { logout } = useLogout()
    const navigate = useNavigate()
    const { user } = useAuthContext()


    const handleLogout = async () => {
        logout()
        setTimeout(() => {
            navigate('/login');
        }, 1000);
    }

    console.log(user)

    return (
        <div className='sidebar'>
            {/* <h1>Immuniso</h1> */}
            <img src={imnLogo} alt="imnLogo" style={{ width: "80%" }} />

            <div className="sideCont">
                <Link
                    to={'/'}
                    className="sdc"
                    style={{
                        backgroundColor: (pathname === '/' || pathname === '/docprof' || pathname.startsWith('/dash2')) ? '#404040' : 'white',
                        color: (pathname === '/' || pathname === '/docprof' || pathname.startsWith('/dash2')) ? 'white' : '#404040'
                    }}


                >
                    <img src={(pathname === '/' || pathname === '/docprof' || pathname.startsWith('/dash2')) ? dashWhite : dashBlack} alt="Dashboard" />
                    <p>Dashboard</p>
                </Link>
                <p className='manset'>Manage</p>
                <Link
                    to={'/consultations'}
                    className="sdc"
                    style={{
                        backgroundColor: pathname === '/consultations' ? '#404040' : 'white',
                        color: pathname === '/consultations' ? 'white' : '#404040'
                    }}
                >
                    <img src={pathname === '/consultations' ? consWhite : consBlack} alt="Consultations" />
                    <p>Consultations</p>
                </Link>
                <Link
                    to={'/doctors'}
                    className="sdc"
                    style={{
                        backgroundColor: pathname === '/doctors' ? '#404040' : 'white',
                        color: pathname === '/doctors' ? 'white' : '#404040'
                    }}
                >
                    <img src={pathname === '/doctors' ? docWhite : docBlack} alt="Doctors" />
                    <p>Doctors</p>
                </Link>
                <Link
                    to={'/patients'}
                    className="sdc"
                    style={{
                        backgroundColor: pathname === '/patients' ? '#404040' : 'white',
                        color: pathname === '/patients' ? 'white' : '#404040'
                    }}
                >
                    <img src={pathname === '/patients' ? patWhite : patBlack} alt="Patients" />
                    <p>Patients</p>
                </Link>
            </div>
            <div className="sideBottom">
                <p className='manset'>Settings</p>
                <Link
                    to={'/myprof'}
                    className="sdc"
                    style={{
                        backgroundColor: pathname === '/profile' ? '#404040' : 'white',
                        color: pathname === '/profile' ? 'white' : '#404040'
                    }}
                >
                    <User className='w-8 h-8' />
                    <p>My Profile</p>
                </Link>
                <Link
                    onClick={handleLogout}
                    className="sdc"
                >
                    <LogOut className='w-8 h-8' />
                    <p>Log Out</p>
                </Link>
            </div>
        </div>
    )
}

export default Sidebar
